    import React from "react";
import {connect} from "react-redux";

const mapStateToProps = ({ initialData: { certificate, benefitLimits } }, ownProps) => ({
    ...ownProps,
    waitingPeriod: certificate.ratedClass.contractTerms.benefitWaitingPeriod,
    waitingPeriodsAdditionalText: benefitLimits.waitingPeriodsAdditionalText,
    waitingPeriodsCoveredPercentageText: benefitLimits.waitingPeriodsCoveredPercentageText,
});

const WaitingPeriods = ({ waitingPeriod, waitingPeriodsCoveredPercentageText, waitingPeriodsAdditionalText }) => (
    waitingPeriod > 0 && (
        <p>
            <b>Waiting period</b><br/>
            If you enroll or add a family member outside of an open enrollment period (annual, new hire, or other qualifying life event), your benefits or any increases are subject to a {waitingPeriod} day waiting period. {waitingPeriodsCoveredPercentageText} {waitingPeriodsAdditionalText}
        </p>
    )
);

export default connect(mapStateToProps)(WaitingPeriods);
